const TranTypeIE = 'Import-Export';
const TranTypeScientific = 'Scientific';

const getAddresUrlPath = () => {
  const transactionType = getAddressTransType();
  return `${process.env.REACT_APP_BASE_URL}/${transactionType}`;
};

const getAddressTransType = () => {
  const currentPath = window.location.pathname;
  if (currentPath.includes('import-export')) {
    return TranTypeIE;
  }
  else {
    return TranTypeScientific;
  }
};

export { getAddresUrlPath };
